<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Internal User</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Internal User</b>
      <b-row>
        <b-col>
          <b-col>
            <b-card class="text-center bg-gray-100">
              <b-row>
                <b-col>
                  <img v-if="url" width="100%" height :src="url" />
                </b-col>
              </b-row>
              <input type="file" ref="file" style="display: none" @change="onChangeFileUpload()" />
              <br />
              <b-link
                @click="$refs.file.click()"
                v-show="!file"
                variant="primary"
                class="text-primary btn"
              >
                <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
                <label class="text-danger">*</label>
              </b-link>
              <b-button @click="$refs.file.click()" v-show="file" variant="outline-primary" class>
                <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
              </b-button>
              <br />
              <div
                v-show="InputImage"
                class="text-danger"
                id="input-answer_en-feedback"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >
                <label v-if="widthImage != 500 || heightImage != 500">Image dimension not correct</label>
                <label v-if="file.size >= 2000000">&nbsp;Image size maximum 2 Mb</label>
              </div>
              <p
                class="text-gray-500"
              >Attach an image (the file must be at least 500x500 pixels and maximum 2MB. Image must be in JPEG, PNG, or GIF format)</p>
            </b-card>
            <br />
            <label class="text-danger">
              *
              <b class="text-dark">Required</b>
            </label>
          </b-col>
        </b-col>
        <b-col md="8">
          <b-row class="mt-4">
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="NIM"
                label-for="input-1"
              >
                <input
                  v-model="nim"
                  v-validate="'required|numeric'"
                  name="nim"
                  class="form-control"
                  placeholder="Enter a NIM"
                />
                <b-form-invalid-feedback id="input-nim-feedback">{{ veeErrors.first('nim') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Username"
                label-for="input-1"
              >
                <input
                  v-model="username"
                  v-validate="'required|alpha_num'"
                  name="username"
                  class="form-control"
                  placeholder="Enter a Username"
                />
                <b-form-invalid-feedback
                  id="input-username-feedback"
                >{{ veeErrors.first('username') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Role"
                label-for="input-1"
              >
                <select
                  class="custom-select"
                  v-validate="'required'"
                  name="role"
                  v-model="selected"
                  required
                >
                  <option value="null">Select Role</option>
                  <option v-for="item in items" :key="item" :value="item.RoleCode">{{item.RoleName}}</option>
                </select>
                <b-form-invalid-feedback id="input-role-feedback">{{ veeErrors.first('role') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Password"
                label-for="input-1"
              >
                <input
                  v-model="password"
                  v-validate="'required'"
                  name="password"
                  type="password"
                  class="form-control"
                  placeholder="Enter a Password"
                  ref="password"
                />
                <b-form-invalid-feedback
                  id="input-password-feedback"
                >{{ veeErrors.first('password') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Confirm Password"
                label-for="input-1"
              >
                <input
                  @input="IsRepassword = true"
                  v-model="re_password"
                  v-validate="'required|confirmed:password'"
                  name="re_password"
                  type="password"
                  class="form-control"
                  placeholder="Enter a Confirm Password"
                />
                <b-form-invalid-feedback
                  id="input-re_password-feedback"
                >{{ veeErrors.first('re_password') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="First Name"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="first_name"
                  name="first_name"
                  id="input-1"
                  class="form-control"
                  placeholder="First Name"
                />
                <b-form-invalid-feedback
                  id="input-first_name-feedback"
                >{{ veeErrors.first('first_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Last Name"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="last_name"
                  name="last_name"
                  class="form-control"
                  placeholder="Last Name"
                />
                <b-form-invalid-feedback
                  id="input-last_name-feedback"
                >{{ veeErrors.first('last_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Email"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required|email'"
                  v-model="email"
                  name="email"
                  id="input-1"
                  class="form-control"
                  placeholder="Email"
                />
                <b-form-invalid-feedback id="input-email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Phone Number"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required|numeric'"
                  v-model="phone_number"
                  name="phone_number"
                  class="form-control"
                  placeholder="Phone Number"
                />
                <b-form-invalid-feedback
                  id="input-phone_number-feedback"
                >{{ veeErrors.first('phone_number') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Address"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <textarea
                  @input="isHiddenAddress = true"
                  tag-name="textarea"
                  placeholder="Address"
                  v-model="address"
                  class="form-control"
                ></textarea>
                <div
                  v-show="isHiddenAddress"
                  class="text-danger"
                  id="input-address-feedback"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >
                  <p v-if="address.length === 0">The Address field is required</p>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <div class="form-group required font-weight-bold">
            <label class="control-label"></label>
            Required
          </div>
          <b-row class="text-right">
            <b-col>
              <b-button
                variant="primary"
                :disabled="veeErrors.any() || !isCompleted || loading"
                @click="post()"
                class="mr-3"
                size="lg"
              >
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: 'InternalUser'}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: '',
      InputImage: false,
      widthImage: null,
      heightImage: null,
      url: '',
      loading: false,
      IsRepassword: false,
      nim: '',
      username: '',
      password: '',
      re_password: '',
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      address: '',
      isHiddenAddress: false,
      selected: null,
      items: [],
    };
  },
  async beforeCreate() {
    this.$store.dispatch('internalUserModule/getRole', { root: true });
  },
  created() {
    this.$store.watch(
      state => state.internalUserModule.role,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
  },
  methods: {
    post() {
      this.loading = true;
      const formData = new FormData();
      formData.append('image', this.file);
      formData.append('nim', this.nim);
      formData.append('username', this.username);
      formData.append('password', this.password);
      formData.append('re-password', this.re_password);
      formData.append('role', this.selected);
      formData.append('fullname', `${this.first_name} ${this.last_name}`);
      formData.append('phone_number', this.phone_number);
      formData.append('email', this.email);
      formData.append('address', this.address);
      this.$store
        .dispatch('internalUserModule/postInternalUser', formData)
        .then((response) => {
          this.loading = false;
          this.$router.push({ name: 'InternalUser' });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response.data;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      this.InputImage = true;
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
  computed: {
    isCompleted() {
      if (this.file) {
        return (
          this.nim
          && this.username
          && this.password
          && this.re_password
          && this.selected
          && this.first_name
          && this.last_name
          && this.email
          && this.phone_number
          && this.address
          && this.file.size <= 2000000
          && this.widthImage == 500
          && this.heightImage == 500
        );
      }
      return (
        this.nim
          && this.username
          && this.password
          && this.re_password
          && this.selected
          && this.first_name
          && this.last_name
          && this.email
          && this.phone_number
          && this.address
      );
    },
  },
};
</script>

<style>
</style>
